// libs
import styled, { css } from 'styled-components'
// icons
import EyeSelectedIconOrigin from '@mui/icons-material/Visibility'
// themes
import { colors } from 'themes'

export const Wrapper = styled('div')<{ isSelected: boolean }>`
  > div {
    padding: 0 16px;
    width: 100%;
    display: flex;
    align-items: center;
  }

  ${({ isSelected }) =>
    isSelected &&
    css`
      > div {
        background: ${colors.gray240};
      }
    `};
`

const IconCSS = css<{ color: string }>`
  margin: 0 !important;
  cursor: pointer;

  &:hover {
    opacity: 0.6;
  }

  path {
    fill: ${({ color }) => color};
  }
`

export const EyeIcon = styled(EyeSelectedIconOrigin)<{ color: string }>`
  height: 25px;
  width: 25px;

  ${IconCSS};
`

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`
